import { apiClient } from "../../base/ApiClient";


export const createFormFields = async (formFields) => {
    try { 
        const response = await apiClient.post(`/form/fields/`, formFields);
        return response.data;
    } catch (error) {
        console.error("Error in posting form fields:", error.response?.data || error.message);
        throw error;
    }
};


export const fetchFormFields = async (formId, clientId, formName) => { 
  try {
    const response = await apiClient.get(`/form/fields/?form_id=${formId}&client_id=${clientId}&form_name=${formName}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching form fields:", error.response?.data || error.message);
    throw error;
  }
};


export const createForms = async (formName) => {
  try { 
      const response = await apiClient.post(`/form/forms/`, formName);
      return response.data;
  } catch (error) {
      console.error("Error in posting form fields:", error.response?.data || error.message);
      throw error;
  }
};


export const getAllForms = async () => {
   try {
    const response = await apiClient.get(`/form/forms/`);
        return response.data;
    } catch (error) {
      console.error("Error fetching form fields:", error.response?.data || error.message);
         throw error;
    }
  };


export const createSubCategory = async (subCategory) => {
  try { 
      const response = await apiClient.post(`/form/sub-forms/`, subCategory);
      return response.data;
  } catch (error) {
      console.error("Error in posting form fields:", error.response?.data || error.message);
      throw error;
  }
};


export const getSubCategory = async (id) => {
  try {
   const response = await apiClient.get(`/form/sub-forms/?form_id=${id}`);
       return response.data;
   } catch (error) {
     console.error("Error fetching form fields:", error.response?.data || error.message);
        throw error;
   }
 };


export const fetchInitialAssessment = async (idOfForm, clientId, form) => {
  try {
   const response = await apiClient.get(`/form/form-fields/grouped/?form_id=${idOfForm}&client_id=${clientId}&form_name=${form}`);
       return response.data;
   } catch (error) {
     console.error("Error fetching form fields:", error.response?.data || error.message);
        throw error;
   }
 };


export const postCheckBox = async (checkboxData) => {
  try {
    const response = await apiClient.post(`/client/initial-assessment/`, checkboxData);
    return response.data;
  } catch (error) {
    console.error("Error in posting form fields:", error.response?.data || error.message);
    throw error;
  }
};